/* Frontend tab plug-in registry (ADR-008).

   Backend returns a manifest of tabs; this map tells us which React
   component to render for each tab id. Tabs whose backend `status !== "ga"`
   render the ComingSoonTab regardless of what's registered here.

   Adding a new tab UI:
     1. Create `tabs/YourTab.jsx`
     2. Register it here with the id that matches the backend TabSpec.id
     3. Ship. The workspace shell picks it up automatically.
*/
import TimelineTab from "./tabs/TimelineTab.jsx";
import ComingSoonTab from "./tabs/ComingSoonTab.jsx";
import DealIntelligenceTab from "./tabs/DealIntelligenceTab.jsx";
import ComparableSalesTab from "./tabs/ComparableSalesTab.jsx";
import DealScoreTab from "./tabs/DealScoreTab.jsx";
import AIRecommendationsTab from "./tabs/AIRecommendationsTab.jsx";
import FixFlipTab from "./tabs/FixFlipTab.jsx";
import RepairEstimateTab from "./tabs/RepairEstimateTab.jsx";
import RentalTab from "./tabs/RentalTab.jsx";
import BRRRRTab from "./tabs/BRRRRTab.jsx";
import WholetailTab from "./tabs/WholetailTab.jsx";
import SellerFinanceTab from "./tabs/SellerFinanceTab.jsx";
import SubjectToTab from "./tabs/SubjectToTab.jsx";
import NovationTab from "./tabs/NovationTab.jsx";
import StrategyCompareTab from "./tabs/StrategyCompareTab.jsx";
import MarketingTab from "./tabs/MarketingTab.jsx";
import LeadScoringTab from "./tabs/LeadScoringTab.jsx";
import TasksTab from "./tabs/TasksTab.jsx";
import BuyersTab from "./tabs/BuyersTab.jsx";
import NegotiationTab from "./tabs/NegotiationTab.jsx";
import AcquisitionIntelTab from "./tabs/AcquisitionIntelTab.jsx";
import OfferIntelTab from "./tabs/OfferIntelTab.jsx";
import ExitIntelTab from "./tabs/ExitIntelTab.jsx";
// BP-001B — the 7 ReSimpli-style shell tabs (Tracy 2026-07-31)
import OverviewTab from "./tabs/OverviewTab.jsx";
import SellerTab from "./tabs/SellerTab.jsx";
import PropertyDetailsTab from "./tabs/PropertyDetailsTab.jsx";
import PhotosFilesTab from "./tabs/PhotosFilesTab.jsx";
import OffersTab from "./tabs/OffersTab.jsx";
import DocumentsTab from "./tabs/DocumentsTab.jsx";
import CommunicationsTab from "./tabs/CommunicationsTab.jsx";

// tab-id → { component, requiresGa? }
const REGISTRY = {
  timeline: { component: TimelineTab },
  deal_intelligence: { component: DealIntelligenceTab },
  comps: { component: ComparableSalesTab },
  deal_score: { component: DealScoreTab },
  ai_recommendations: { component: AIRecommendationsTab },
  fixflip: { component: FixFlipTab },
  rental: { component: RentalTab },
  brrrr: { component: BRRRRTab },
  wholetail: { component: WholetailTab },
  seller_finance: { component: SellerFinanceTab },
  subject_to: { component: SubjectToTab },
  novation: { component: NovationTab },
  strategy_compare: { component: StrategyCompareTab },
  marketing: { component: MarketingTab },
  lead_score: { component: LeadScoringTab },
  tasks: { component: TasksTab },
  buyers: { component: BuyersTab },
  negotiation: { component: NegotiationTab },
  acquisition_intel: { component: AcquisitionIntelTab },
  offer_intel: { component: OfferIntelTab },
  exit_intel: { component: ExitIntelTab },
  repair_estimate: { component: RepairEstimateTab },
  // BP-001B ReSimpli tabs — surface existing data, no new endpoints.
  overview:          { component: OverviewTab },
  seller:            { component: SellerTab },
  property_details:  { component: PropertyDetailsTab },
  photos:            { component: PhotosFilesTab },
  offers:            { component: OffersTab },
  documents:         { component: DocumentsTab },
  communications:    { component: CommunicationsTab },
};

export function resolveTabComponent(tab) {
  // If the backend says the tab isn't enabled yet, we render the shell.
  if (!tab?.enabled) return ComingSoonTab;
  const entry = REGISTRY[tab.id];
  return entry?.component ?? ComingSoonTab;
}
